<mat-dialog-content>
  <div class="flex flex-col gap-4">
    <h2 class="font-black text-chathams-blue uppercase">Desativar módulo "{{ module.name }}"?</h2>

    <p class="text-sm text-gray-700">
      O módulo sai na hora de todos os totens que o usam e deixa de aparecer para seleção em novos setups.
    </p>

    <div class="rounded-2xl bg-iceberg p-4 text-sm text-chathams-blue">
      <ng-container *ngIf="impact; else impactPending">
        <p class="font-bold mb-1">Serão afetados:</p>
        <ul class="list-disc pl-5">
          <li>{{ impact.devices | i18nPlural: { '=1': '# totem', other: '# totens' } }}</li>
          <li>{{ impact.companies | i18nPlural: { '=1': '# empresa', other: '# empresas' } }}</li>
          <li>{{ impact.employees | i18nPlural: { '=1': '# usuário', other: '# usuários' } }}</li>
        </ul>
      </ng-container>
      <ng-template #impactPending>
        <p *ngIf="impactError; else loadingImpact">
          Não foi possível calcular o impacto. Confira os setups que usam o módulo antes de continuar.
        </p>
        <ng-template #loadingImpact><p>Calculando impacto...</p></ng-template>
      </ng-template>
    </div>

    <label *ngIf="critical" class="flex flex-col gap-1 text-sm text-gray-700">
      <span>
        Este é um módulo crítico. Digite <strong>{{ module.name }}</strong> para confirmar.
      </span>
      <input [formControl]="confirmName" type="text" class="form-input" autocomplete="off" />
    </label>

    <div class="flex justify-end gap-2">
      <button type="button" class="px-5 btn btn--primary h-35" cdkFocusInitial [mat-dialog-close]="false">
        Cancelar
      </button>
      <button
        type="button"
        class="px-5 btn btn--secondary h-35 disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="!canConfirm"
        [mat-dialog-close]="true"
      >
        Desativar
      </button>
    </div>
  </div>
</mat-dialog-content>
